import { Button } from "primereact/button"
import { Checkbox } from "primereact/checkbox"
import { IconField } from "primereact/iconfield"
import { InputIcon } from "primereact/inputicon"
import { InputText } from "primereact/inputtext"
import { Tooltip } from "primereact/tooltip"
import { useContext, useEffect, useRef, useState } from "react"
import { Controller, set, useForm } from "react-hook-form"
import { InfoInputs } from "./InfoInputs"
import { getBuroInfo, submitFormLeasingInfo, registrarConsentimientoBuro } from "../fecthLeasing"
import { AuthContext } from "../../../../../../Context/AuthContext"
import { Toast } from "primereact/toast"
import { Loader } from "../../../../../../Components"
import axios from "axios"
import { url } from "../../../../../../env"
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { SelectedPerson } from "../../Buro1/components/SelectedPerson"
import { InfoTypePerson } from "../../Buro1/components/InfoTypePerson"
import { buro1CSS } from "../../Buro1/Buro1.css"


const validateField = (field, message) => {
    if (field === '') {
        return {
            type: 'required',
            message
        };
    }
    return null;
};

const validateEmail = (email, confirmEmail, fieldName) => {
    if (email === '') {
        return {
            type: 'required',
            message: `${fieldName} es requerido`
        };
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        return {
            type: 'invalid',
            message: `Formato de ${fieldName.toLowerCase()} inválido`
        };
    }
    if (confirmEmail && email !== confirmEmail) {
        return {
            type: 'mismatch',
            message: 'Los correos electrónicos no coinciden'
        };
    }
    return null;
};

const customResolver = async (data) => {
    const errors = {};

    errors.name = validateField(data.name, 'Nombre es requerido');
    errors.rfc = validateField(data.rfc, 'RFC es requerido');
    errors.ciec = validateField(data.ciec, 'Clave Ciec es requerida');
    errors.phone = validateField(data.phone, 'Teléfono es requerido');
    errors.email = validateEmail(data.email, data.confirmEmail, 'Correo electrónico');
    errors.confirmEmail = validateField(data.confirmEmail, 'Confirmar correo electrónico es requerido');
    errors.acceptTermsConditions = !data.acceptTermsConditions ? { type: 'required', message: 'Debes aceptar los términos y condiciones' } : null;
    errors.isTrueInfo = !data.isTrueInfo ? { type: 'required', message: 'Debes certificar que la información es correcta' } : null;

    // if (data.typePerson === 2) {
    //     errors.isMoralPersonName = validateField(data.isMoralPersonName, 'Nombre es requerido');
    //     errors.isMoralPersonRfc = validateField(data.isMoralPersonRfc, 'RFC es requerido');
    //     errors.isMoralPersonCiec = validateField(data.isMoralPersonCiec, 'Clave Ciec es requerida');
    //     errors.isMoralPersonPhone = validateField(data.isMoralPersonPhone, 'Teléfono es requerido');
    //     errors.isMoralPersonEmail = validateEmail(data.isMoralPersonEmail, data.isMoralPersonConfirmEmail, 'Correo electrónico');
    //     errors.isMoralPersonConfirmEmail = validateField(data.isMoralPersonConfirmEmail, 'Confirmar correo electrónico es requerido');
    // }
    if (data.rfc.length < 12) {
        errors.rfc = {
            type: 'invalid',
            message: 'RFC debe tener al menos 12 caracteres'
        };
    }

    return {
        values: data,

        errors: Object.keys(errors).reduce((acc, key) => {
            if (errors[key]) acc[key] = errors[key];
            return acc;
        }, {})
    };
};

export const LeasingForm = ({ setPage, setPageStep3, setStep, pageStep3, state }) => {

    const { authInfo } = useContext(AuthContext);

    const defaultVals = {
        name: '',
        rfc: '',
        ciec: '',
        phone: +pageStep3.infoUser.phone,
        email: authInfo.user.email,
        // para ver que metodo utilizo, syntageo buro
        typeMethod: pageStep3.selectedMethod,
        confirmEmail: '',
        typePerson: pageStep3.selectedTypePerson,
        acceptTermsConditions: false,
        isTrueInfo: false,
        isMoralPersonName: '',
        isMoralPersonCiec: '',
        isMoralPersonRfc: '',
        isMoralPersonPhone: '',
        isMoralPersonEmail: '',
        isMoralPersonConfirmEmail: '',
    };


    const {
        register,
        handleSubmit,
        watch,
        formState: { errors, isValid, isDirty },
        reset,
        setValue,
        getValues,
        control,
        setError,
        clearErrors
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            ...defaultVals
        },
        // resolver: customResolver
    });



    const [loading, setLoading] = useState(false);

    // for sintage
    const [isErrorFetching, setIsErrorFetching] = useState(false);
    const [isValidCredentials, setIsValidCredentials] = useState(null);
    const [getZipCode, setGetZipCode] = useState(null);
    const [uuid, setUuid] = useState(null);
    const [retryCount, setRetryCount] = useState(0);
    const [message, setMessage] = useState("");
    const tryIntents = useRef(0);

    const checkUserValidSyntage = (id, skipErrorCheck = false) => {
        setLoading(true);

        // Solo verificar isErrorFetching si no se solicita saltar la validación
        if (!skipErrorCheck && isErrorFetching) {
            setIsErrorFetching(false);
            setLoading(false);
            return
        }

        axios
            .get(`${url}/fecthSyntage/credentials/${id}`, {
                headers: {
                    'Authorization': `Bearer ${authInfo.token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then((res) => {
                if (res.data.status_credentials === "pending") {
                    if (retryCount < 2) {
                        setRetryCount(retryCount + 1);
                    } else {
                        setIsErrorFetching(true);
                        setMessage("Error al validar, intente de nuevo ");
                        // setRetryCount(10);
                        setLoading(false);
                        if (tryIntents.current == 1) {
                            handleVisible(true, "continueAgain");

                        }
                        if (tryIntents.current >= 2) {
                            handleVisible(true, "continue");
                        }
                        return;
                    }
                } else {
                    //reseteamos intentos por si hay otra peticion
                    setRetryCount(0);
                    setLoading(false);

                    // en caso de que sea otro status diferente de valid
                    if (res.data.status_credentials !== "valid") {
                        setIsErrorFetching(true);
                        setMessage("Error al validar credenciales");

                        setRetryCount(0);
                        if (tryIntents.current >= 2) {
                            handleVisible(true, "continue");
                            setLoading(false);
                        }
                        if (tryIntents.current == 1) {
                            setLoading(false);
                            handleVisible(true, "continueAgain");
                            // return
                        }
                        return;
                    }
                    setLoading(false);
                    setIsValidCredentials(true);
                    //   setPage(4);
                    // setStep(4)
                    // continuar con flujo normal CREDENCIALES CORRECTAS
                    tryIntents.current = 2;
                    saveInfoLeasing(getValues());
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const timerCheckCredentials = () => {
        // if(isErrorFetching) {
        //     // setIsErrorFetching(false);
        //     setLoading(false);
        //     // if(tryIntents.current >= 2) {
        //     //     setVisible(true);
        //     //     setLoading(false);
        //     // }
        //     // return
        // }else {
        //     setLoading(true);
        // }
        setIsErrorFetching(false);
        return setTimeout(() => {
            checkUserValidSyntage(uuid);
        }, 8000);

    }

    useEffect(() => {
        // if(retryCount == 3) {
        //   setRetryCount(0);
        // }
        if (uuid === null || retryCount == 3 || isValidCredentials) return;

        const timer = timerCheckCredentials();


        return () => clearInterval(timer);

    }, [retryCount]);

    const accept = (mode) => {

        if (mode === "buroError") {
            saveInfoLeasing(getValues(), "continueSaveInfo");

            // setPageStep3(prev => ({
            //     ...prev, completeLeasingInfo: true,
            //     selectedTypePerson: getValues().typePerson,
            //     isLoggedSyntage: true
            // }));
            // setPage(4);
            // return;
        }


        setIsValidCredentials(true);
        tryIntents.current = 2;
        setLoading(true);
        saveInfoLeasing(getValues());
    }
    const [visible, setVisible] = useState(false);
    const [visibleMode, setVisibleMode] = useState("");

    const handleVisible = (open, mode) => {
        setVisible(open);
        setVisibleMode(mode);
    }

    const rfcRef = useRef(null);

    const onSubmit = async (data) => {
        const selectedType = pageStep3.selectedTypePerson;

        // PF flow: skip Syntage entirely
        if (selectedType === 3) {
            return saveInfoLeasing(data);
        }

        // PFAE and PM: use Syntage flow
        // For PFAE, RFC comes from data.rfc (personal data section)
        let rfc = selectedType === 1 ? data.rfc : data.rfcSyntage;
        let password = data.ciecSyntage;
        setIsErrorFetching(false);
        setLoading(true);
        if (tryIntents.current <= 1) {

            if (password.length < 8) {
                setIsErrorFetching(true);
                setMessage("Al menos 8 caracteres");
                setLoading(false);
                return;
            }
            const token = localStorage.getItem('token');
            axios
                .post(`${url}/fecthSyntage/credentials`, {
                    rfc,
                    password,
                    email: authInfo.user.email,
                    secret: state.budget_secret,
                    id: state.budget_id
                },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`, // Incluir el token en los headers
                        },
                    }
                )
                .then((res) => {
                    // Verificar si el RFC ya existe (409 Conflict)
                    if (res.data[0] === 409) {
                        setIsErrorFetching(true);
                        const errorMessage = res.data[1].message || "Este RFC ya está registrado con otra cuenta";
                        setMessage(errorMessage);
                        show(errorMessage);

                        // Establecer el error directamente en el campo de RFC
                        setError('rfcSyntage', {
                            type: 'manual',
                            message: errorMessage
                        });

                        setLoading(false);
                        tryIntents.current = 0;
                        return;
                    }

                    // syntage solo regresa estos status de error
                    if (res.data[0] !== 400 && res.data[0] !== 401) {
                        // Limpiar errores previos del campo RFC si la petición es exitosa
                        clearErrors('rfcSyntage');

                        // IMPORTANTE: Resetear isErrorFetching ANTES de llamar checkUserValidSyntage
                        // Si no, checkUserValidSyntage retornará inmediatamente sin hacer nada
                        setIsErrorFetching(false);
                        setIsValidCredentials(false);
                        setRetryCount(0);

                        setTimeout(() => {
                            setUuid(res?.data[1]?.id);
                            // checar si fueron validas estas credenciales
                            // if(setIsErrorFetching) {
                            //     setLoading(false);
                            //     return
                            // }
                            // Pasar skipErrorCheck=true para evitar que el check asíncrono cause early return
                            checkUserValidSyntage(res.data[1].id, true);
                        }, 5000);
                        tryIntents.current = tryIntents.current + 1;


                    } else {
                        setIsErrorFetching(true);

                        // para mostrar mensaje de error
                        setMessage("Rfc o contraseña incorrectos");
                        show("Rfc o contraseña incorrectos");
                        handleVisible(true, "incorrect");

                        setLoading(false);
                        tryIntents.current = tryIntents.current + 1;

                    }
                })
                .catch((err) => {
                    setIsErrorFetching(true);
                    setLoading(false);

                    tryIntents.current = tryIntents.current + 1;
                    if (tryIntents.current == 1) {
                        handleVisible(true, "continueAgain");
                        return;
                    }
                    if (tryIntents.current >= 2) {
                        handleVisible(true, "continue");
                        return;
                    }
                    // para mostrar mensaje de error
                    setMessage("Rfc o contraseña incorrectos");
                    show("Rfc o contraseña incorrectos");
                    handleVisible(true, "incorrect");
                });
        } else if (tryIntents.current >= 1 && !isValidCredentials) {
            // console.log("parece que hay un error en las credenciales, vuelva a intentar", 
            setLoading(false);
            handleVisible(true, "continue");
            // confirmDialog({
            //     message: 'Parece que hubo un error al validar tus credenciales, ¿Deseas continuar?',
            //     header: 'Confirmación',
            //     icon: 'pi pi-exclamation-triangle',
            //     defaultFocus: 'accept',
            //     accept,
            // });
        } else {
            if (visibleMode === "buroError") {
                saveInfoLeasing(getValues(), "continueSaveInfo");
            } else if (visibleMode === "verifyBuro") {
                accept();
            }
            else {
                saveInfoLeasing(getValues());
            }
        }
    }



    // for syntage
    const saveInfoLeasing = async (data, mode = "") => {
        setLoading(true);
        data.typePerson = pageStep3.selectedTypePerson;
        data.typeMethod = pageStep3.selectedMethod;
        try {

            // Consultar buró para todos los subtipos (PF, PFAE y PM)
            if (pageStep3.selectedTypePerson === 1 || pageStep3.selectedTypePerson === 2 || pageStep3.selectedTypePerson === 3) {
                setLoading(true);

                // P0.3: el consentimiento tiene que quedar registrado ANTES
                // de consultar buró, o no sirve de evidencia. Los checkboxes
                // isTrueInfo / acceptTermsConditions ya son required más
                // abajo en este mismo formulario, así que si llegamos aquí
                // el usuario ya dio clic; esto solo lo deja constancia. No
                // bloquea la consulta si el registro falla.
                await registrarConsentimientoBuro();

                // Primer intento para getBuroInfo
                let ress = await getBuroInfo(data, pageStep3.selectedTypePerson);

                if (ress?.error || ress === 500) {
                    const errorMsg = ress?.message || "Error al consultar buró.";
                    show(errorMsg);
                    setLoading(false);

                    setVisibleMode("buroError");
                    setVisible(true);
                    return;
                }

            }


            // Primer intento para submitFormLeasingInfo
            let res = await submitFormLeasingInfo(data);

            if (res && res.creditrust) {
                if (res.creditrust.success) {
                    show("Registro en Creditrust exitoso");
                } else {
                    show(`Aviso Creditrust: ${res.creditrust.message || 'Error desconocido'}`);
                }
            }

            if (res === 500) {
                show("Error al enviar la información");

                // Segundo intento para submitFormLeasingInfo
                res = await submitFormLeasingInfo(data);

                if (res === 500) {
                    show("Error al enviar la información. Intentando nuevamente...");
                    setLoading(false);
                    setVisibleMode("continue");
                    setVisible(false);
                    return;
                }
            }





            // Si ambas operaciones fueron exitosas
            setPageStep3(prev => ({
                ...prev,
                completeLeasingInfo: true,
                selectedTypePerson: data.typePerson,
                isLoggedSyntage: true
            }));
            setPage(4);
            setLoading(false);

        } catch (error) {
            console.error("Error en el proceso:", error);
            show("Error en el proceso. Por favor, intente nuevamente.");
            setLoading(false);
        }
    }




    const cleanInputs = () => {
        reset({
            ...getValues(),
            typePerson: 1,
            // isMoralPersonName: '',
            // isMoralPersonCiec: '',
            // isMoralPersonRfc: '',
            // isMoralPersonPhone: '',
            // isMoralPersonEmail: '',
            // isMoralPersonConfirmEmail: '',
        }, {
            keepErrors: true,
            keepDirty: true,
            keepIsSubmitted: false,
            keepTouched: false,
            keepIsValid: false,
            keepSubmitCount: false,
            keepIsValidating: false,
        });
    }



    const toast = useRef(null);

    const show = (err) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: err, life: 3000 });
    };

    let errs = Object.keys(errors);

    const [hasErrors, setHasErrors] = useState(false);

    const handleErros = async () => {
        const data = getValues();
        const result = await customResolver(data);

        // Si hay errores, actualiza el estado
        setHasErrors(Object.keys(result.errors).length > 0);
    };




    return (
        <div css={buro1CSS()}>
            {(
                <ConfirmDialog
                    group="declarative"
                    escape={true}
                    visible={visible}
                    onHide={() => setVisible(false)}
                    message={
                        visibleMode === "continue"
                            ? "Hubo un error al validar tus credenciales, ¿Deseas continuar con el proceso?"
                            : visibleMode === "buroError"
                                ? "Hubo un error al consultar el buró de crédito, Revisa tus datos y vuelve a intentar."
                                : "Error al validar credenciales, verifica y vuelve a intentar."
                    }
                    header="Aviso"
                    icon="pi pi-exclamation-triangle"
                    //    reject={reject}
                    style={{ width: '50vw' }}
                    breakpoints={{ '1100px': '75vw', '960px': '90vw' }}
                    content={({ headerRef, contentRef, footerRef, hide, message }) => (
                        <div className="flex flex-column align-items-center p-5 surface-overlay border-round">
                            {/* <div className="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                                <i className="pi pi-question text-5xl"></i>
                            </div> */}
                            <span className="font-bold text-2xl block mb-2 mt-4" ref={headerRef}
                                style={{
                                    background:
                                        "linear-gradient(90deg, #34C6F1 6.22%, #1FDD8F 77.34%)",
                                    WebkitBackgroundClip: "text",
                                    backgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                }}
                            >
                                {message.header}
                            </span>
                            <p className="mb-0" ref={contentRef}
                                style={{
                                    color: "#77787B",
                                    // WebkitTextFillColor: "transparent",
                                    marginBottom: "1rem",
                                    fontSize: "calc(0.6rem + 0.9vw)",
                                }}
                            >
                                {message.message}
                            </p>
                            <div className="flex align-items-center gap-4 mt-4
                                flex-wrap
                                m-auto justify-content-center
                            " ref={footerRef}>
                                {visibleMode === "buroError" && (
                                    <Button
                                        label="Verificar"
                                        onClick={(event) => {
                                            hide(event);
                                            setVisible(false);
                                            setIsErrorFetching(false);
                                            setVisibleMode("verifyBuro");
                                            // No avanzar, permitir al usuario revisar y corregir sus datos
                                        }}
                                        style={{
                                            backgroundColor: "#34C6F1",
                                            color: "white",
                                            border: "1px solid #34C6F1",
                                            borderRadius: "5px",
                                        }}
                                        className="w-8rem text-white"
                                    />
                                )}

                                {visibleMode !== "buroError" && (
                                    <Button
                                        label="Continuar"
                                        onClick={(event) => {
                                            hide(event);
                                            if (visibleMode === "continue") {
                                                accept(visibleMode);
                                            } else if (visibleMode === "incorrect") {
                                                setVisible(false);
                                                setIsErrorFetching(false);
                                                setLoading(false);
                                            }
                                            else {
                                                setVisible(false);
                                                setIsErrorFetching(false);
                                            }
                                        }}
                                        style={{
                                            backgroundColor: "#22ec9a",
                                            color: "white",
                                            border: "1px solid #22ec9a",
                                            borderRadius: "5px",
                                        }}
                                        className="w-8rem text-white"
                                    />
                                )}
                            </div>
                        </div>
                    )}
                />
            )}

            {loading && <Loader msg={isValidCredentials ? "Guardando tu informacion" : getZipCode ? "Obteniendo tu domicilio" : "Validando credenciales"} />}
            <Toast ref={toast} />
            <form className="w-full m-auto" onSubmit={handleSubmit(onSubmit)}>
                <div style={{ alignItems: "center" }} className="px-0 py-3  col-12 flex flex-column gap-4 justify-center items-center">
                    {/* <div className="ChooseTypePersonBtn">
                        <Button
                            label="Persona Física"
                            className={`w-full Button Blue Button py-2 ${watch('typePerson') === 2 ? 'withoutSelected' : ''}`}
                            tooltip="Persona Física con Actividad Empresarial. Eres independiente, y puedes recibir ingresos y facturas a tu nombre."
                            tooltipOptions={{ position: 'top' }}
                            onClick={(e) => {
                                e.preventDefault();
                                setPageStep3(prev => ({ ...prev, selectedTypePerson: 1 }))
                                cleanInputs()
                            }
                            }
                        // disabled = {watch('selectedPersonType') === 2}
                        />


                        <Button
                            label="Persona Moral"
                            className={`w-full Button Blue Button py-2 ${watch('typePerson') === 1 ? 'withoutSelected' : ''}`}
                            tooltip="Mis facturas tienen el nombre de la empresa"
                            tooltipOptions={{ position: 'top' }}
                            onClick={(e) => {
                                e.preventDefault();
                                setPageStep3(prev => ({ ...prev, selectedTypePerson: 2 }))
                                setValue('typePerson', 2, {
                                    shouldDirty: true
                                })
                            }
                            }
                        // disabled = {watch('selectedPersonType') === 1}
                        />
                    </div> */}
                    <SelectedPerson
                        pageStep3={pageStep3}
                        setPageStep3={setPageStep3}
                        reset={reset}

                    />
                    <span className="NormalMedium font-small" style={{
                        textAlign: 'center',
                        width: '100%',
                        maxWidth: '100%',
                        display: 'block',
                        margin: '0 auto',
                        padding: '1rem',
                        fontSize: '.8rem'
                    }}>
                        Ten contigo
                        <strong>
                            {pageStep3.selectedTypePerson === 2
                                ? ' Datos personales de un accionista y/o representante legal'
                                : ' Datos personales del titular'
                            }
                            {(pageStep3.selectedTypePerson === 1 || pageStep3.selectedTypePerson === 2) && (
                                <span><br />RFC y contraseña del SAT (CIEC)</span>
                            )}
                        </strong>
                    </span>


                    <InfoTypePerson
                        typePerson={pageStep3.selectedTypePerson}
                        control={control}
                        register={register}
                        defaultVals={defaultVals}
                        setValue={setValue}
                        errors={errors} // Pasa el objeto errors completo
                        setLoading={setLoading}
                        setGetZipCode={setGetZipCode}
                        watch={watch}
                    />


                    {/* <InfoInputs register={register} errors={errs} setValue={setValue} isErrorFetching={isErrorFetching} message={message} rfcRef={rfcRef} selectedTypee={pageStep3.selectedTypePerson} /> */}

                    {/* {pageStep3.selectedTypePerson === 2 &&
                        <InfoInputs register={register} isMoralPerson={true} errors={errs} setValue={setValue} selectedTypee={pageStep3.selectedTypePerson} />
                    } */}


                    <div className=" ComplementInfo grid grid-cols-1 md:grid-cols-3 gap-4 "
                        style={{
                            justifyContent: "flex-start",
                            flexDirection: "column",
                            margin: 'auto',
                            width: window.innerWidth <= 768 ? '80%' : '615px',
                            maxWidth: '615px',
                        }}
                    >
                        <div className="flex align-items-center">
                            <Controller
                                name="isTrueInfo"
                                control={control}
                                defaultValue={false}
                                rules={{ required: 'Debes certificar que la información es correcta' }}
                                render={({ field }) => (
                                    <Checkbox

                                        inputId="confirmInfo"
                                        checked={field.value}
                                        onChange={e => field.onChange(e.checked)}
                                        className={errors.isTrueInfo ? 'p-invalid' : ''}
                                    />
                                )}
                            />
                            <label htmlFor="confirmInfo" className="ml-2">
                                Certifico que esta información, a mi mejor entendimiento, es completa y precisa
                            </label>


                        </div>
                        <div className="flex align-items-center">
                            <Controller
                                name="acceptTermsConditions"
                                control={control}
                                defaultValue={false}
                                rules={{ required: 'Debes aceptar los términos y condiciones' }}
                                render={({ field }) => (
                                    <Checkbox
                                        inputId="termsConditions"
                                        checked={field.value}
                                        onChange={e => field.onChange(e.checked)}
                                        className={errors.acceptTermsConditions ? 'p-invalid' : ''}
                                    />
                                )}
                            />
                            <label htmlFor="termsConditions" className="ml-2">
                                Acepto términos y condiciones
                            </label>
                        </div>
                        <span className="Disclaimer">
                            Autorizo expresamente a CONDUCE CAPITAL
                            SAPI DE CV., para llevar a cabo investigaciones sobre mi
                            comportamiento crediticio en las sociedades de información
                            crediticia (SIC) que estime conveniente. Conozco la naturaleza y
                            alcance de la información que se solicitará, del uso se le dará y
                            que se podrán realizar consultas periódicas de mi historial
                            crediticio. Consiento que esta autorización tenga una vigencia de
                            3 años contados a partir de hoy, y en su caso mientras mantengamos
                            relación jurídica. Acepto que este documento queda bajo propiedad
                            de CONDUCE CAPITAL SAPI DE CV. para efectos de control y
                            cumplimiento del artículo 28 de la LRSIC.
                        </span>
                    </div>

                    <Button
                        label="Continuar"
                        icon="pi pi-check"
                        className="Green py-3 mt-4"
                        style={{
                            width: window.innerWidth <= 768 ? '80%' : '615px',
                            maxWidth: '615px',
                        }}
                        loading={false}
                        // disabled={!isValid || hasErrors || getValues().isTrueInfo === false || getValues().acceptTermsConditions === false}
                        type="submit"
                    />

                </div>
                <div className="Shadow"></div>
            </form>
        </div>
    )
}
